// local
import { STATE_URL } from './constants.js';
// packages

import {
  createFeed,
  createRaceFeed,
  createCandidateLookup,
  createSubunitLookup,
} from './stores.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const feed = await createFeed(STATE_URL);

  //AT A GLANCE GOV AND AG
  const atAGlanceRaces = [
    {
      race: 'prop-33',
      id: 'CA-I83066-2024-11-05',
      label: 'Proposition 33:<br/> Expand Local Rent Control',
    },
    {
      race: 'prop-36',
      id: 'CA-I83069-2024-11-05',
      label:
        'Proposition 36:<br/> Increase Sentences for Drug and Theft Crimes',
    },
  ];

  atAGlanceRaces.forEach((r) => {
    r['store'] = /** @type {import('./types.d').ReadableRace} */ (
      createRaceFeed(feed, r['id'])
    );
  });

  let aagContainer = findSvelteComponentContainer('#aag-california');

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */
    aagContainer,
    {
      feed: atAGlanceRaces,
      crosswalk,
    }
  );
}

main().catch(console.error);
